import { defaults as _defaults } from "lodash";
// import model from '../../models'
import _ from "lodash";

// Склонение по полу
const sex = {
  // Средний
  0: {
    required: "обязательно",
    must: "должно",
    correct: "корректное",
    select: "выбрано"
  },
  // Мужской
  1: {
    required: "обязателен",
    must: "должен",
    correct: "корректный",
    select: "выбран"
  },
  // Женский
  2: {
    required: "обязательна",
    must: "должна",
    correct: "корректную",
    select: "выбрана"
  },
  // Множественное
  3: {
    required: "обязательны",
    must: "должны",
    correct: "корректные",
    select: "выбраны"
  }
};

// Стандартные настройки
const optionsDefault = {
  name: "поле",
  autoFormatName: true,
  sex: 0,
  required: false,
  checkLength: false,
  isNumber: false,
  isNumberInteger: false,
  isNumberPositive: false,
  isSelect: false,
  isBoolean: false,
  min: 8,
  max: 32
};

const getName = config => {
  if (config.autoFormatName) {
    return `${String(config.name)
      .charAt(0)
      .toUpperCase() + String(config.name).substring(1)}`;
  } else {
    return `${String(config.name)}`;
  }
};

export default function validate(text, options) {
  let config = {};
  let errors = [];

  // Применяем параметры
  // if (typeof options === 'string' && model[options]) {
  //   config = _defaults(model[options], optionsDefault);
  // } else {
  config = _defaults(options, optionsDefault);
  // }

  // Обязательно?
  if (config.required) {
    // Это число
    if (config.isNumber) {
      // Временное число для сравнения
      const textNumber = _.toNumber(text);

      // Это число
      if (_.isNaN(textNumber)) {
        // Например: Поле обязательно
        errors.push(`${getName(config)} ${sex[config.sex].required}`);
      }

      // Проверка на integer
      if (config.isNumberInteger && !_.isInteger(textNumber)) {
        // Например: Поле должно быть целым числом, например: 1, 0, 500, 1000, -50
        errors.push(
          `${getName(config)} ${
            sex[config.sex].must
          } быть целым числом, например: 1, 0, 500, 1000, -50`
        );
      }

      // Проверка на позитив
      if (config.isNumberPositive && !_.gt(textNumber, 0)) {
        // Например: Поле должно быть больше 0
        errors.push(`${getName(config)} ${sex[config.sex].must} быть больше 0`);
      }
    } else if (config.isSelect) {
      // Текст пустой
      if (!text) {
        // Например: Поле должно быть выбрано
        errors.push(
          `${getName(config)} ${sex[config.sex].must} быть ${
            sex[config.sex].select
          }`
        );
      }
    } else if (config.isBoolean) {
      // Это Boolean
      if (!_.isBoolean(text)) {
        // Например: Поле обязательно
        errors.push(`${getName(config)} ${sex[config.sex].required}`);
      }
    } else {
      // Текст пустой
      if (!text) {
        // Например: Поле обязательно
        errors.push(`${getName(config)} ${sex[config.sex].required}`);
      }

      // Проверка на длину
      if (config.checkLength) {
        // Проверка на min и max
        if (text.length < config.min || text.length > config.max) {
          // Например: Поле должно быть от 3 до 15 символов
          errors.push(
            `${getName(config)} ${sex[config.sex].must} быть от ${
              config.min
            } до ${config.max} символов`
          );
        }
      }
    }
  } else {
    // Проверка на длину
    if (config.checkLength) {
      // Проверка max
      if (text.length > config.max) {
        // Например: Поле должно быть до 15 символов
        errors.push(
          `${getName(config)} ${sex[config.sex].must} быть до ${
            config.max
          } символов`
        );
      }
    }
  }

  // Если ли проверочная функция на regexp?
  if (text && text.length && config.regexp) {
    if (!config.regexp.test(text)) {
      errors.push(
        `Введите ${sex[config.sex].correct} ${String(
          config.name
        ).toLowerCase()}`
      );
    }
  }

  // Add validate enum
  // if (config.enum) {
  //   let isError = true;

  //   for (let i = 0; i < config.enum.length; i++) {
  //     if (text === config.enum[i].value) {
  //       isError = false;
  //     }
  //   }

  //   if (isError) {
  //     errors.push(`${getName(config)} ${sex[config.sex].must} - необходимо выбрать один из представленных вариантов}`);
  //   }
  // }

  return {
    valid: !errors.length,
    errors: errors
  };
}
